/* jshint node:true */
'use strict';

var React = require('react');

/* Components */
var LeagueTable         = require('./LeagueTable.jsx');
var NewsList            = require('./NewsList.jsx');
var Conversation        = require('./Conversation.jsx');
var Advert = require('../../common/Advert.jsx');
var AdReloaderMixin = require('../../../mixins/AdReloaderMixin.js');

var TabConversation = React.createClass({

    displayName: 'TabConversation',
    
    mixins : [ AdReloaderMixin ],
    
    getInitialState : function(){
        return {
            adWrapSelector : '#reactContainer .react-ad'
        };
    },

    componentDidMount: function(){
        window.fbAsyncInit = function() {
            FB.Canvas.setAutoResize();
        }
    },

    render: function () {

        var oStore      = this.props.store;

        /* Load in the data from the Store */
        var aLeagueTable    = oStore.getLeagueTable();
        var leagueName = oStore.getLeagueName();
        var newsList        = oStore.getNewsList();

        return (
            <div className="layout-bc">
                <section className="col-b">
                    <Conversation key="conversation" query={this.props.query} />
                </section>
                <section className="col-c">
                    <article className="ad-300">
                        <div className="ad-center">
                            <Advert id='game.rhs.mpu' className="ad-slot-incontent ad-wrapper" slotType="incontent" />
                        </div>
                    </article>
                    <LeagueTable tableHref={this.props.tableHref} name={leagueName} table={aLeagueTable} />
                    <NewsList header={newsList.header} link={newsList.link} articles={newsList.articles} />
                </section>
            </div>
        );
    }
});

module.exports = TabConversation;









/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TabConversation.jsx
 **/